export default __webpack_public_path__ + "static/media/hostfully_step18.27c14758.png";